import {Injectable} from '@angular/core';
import {HttpService} from '../technique/http.service';
import {Observable} from 'rxjs';
import {UdpRepasPonderationDto} from '../../dtos/unite-de-production/udp-repas-ponderation-dto';
import {ResponseWrapper} from '../../suppliers/wrappers/response-wrapper';

const URL_FIND = `dolrest/gestion-unites-de-production/repas-ponderation/`;
const URL_SAVE = `dolrest/gestion-unites-de-production/repas-ponderation/save`;

@Injectable({
  providedIn: 'root'
})
export class GestionUniteProduction__RepasPonderationService {

  constructor(private httpSvc: HttpService) {}

  findByIdUdp = (idUdp: number): Observable<ResponseWrapper<UdpRepasPonderationDto>> =>
    this.httpSvc.get(`${URL_FIND}${idUdp}`, null);

  saveList = (list: UdpRepasPonderationDto[]): Observable<ResponseWrapper<UdpRepasPonderationDto>> =>
    this.httpSvc.post(URL_SAVE, list);

}
